import { PRICING_URL } from '../demo/demoLinks.ts';

// "Sign up" opens the pricing on the Forge page, which holds the payment link,
// rather than dropping someone straight into checkout. Paying there creates the
// buyer's workspace and sends them to /welcome.
export const SIGNUP_URL = PRICING_URL;
